/* eslint-disable -- UX wireframe; not held to app lint rules */
import { T } from "../../tokens";
import ZiniHubWizardApp from "../ZiniHub/shared/ZiniHubWizardApp";
import { ROUTES } from "../ZiniHub/shared/zinihubRoutes";
import { IA } from "../ZiniHub/shared/zinihubIA";
import { getShellsForApp } from "../ZiniHub/shared/zinihubShells";
import { ADMIN_FLOWS } from "../ZiniHub/shared/zinihubAdminFlows";
import { ADMIN_ISSUES } from "../ZiniHub/shared/zinihubIssues";
import { FOLDER_STRUCTURE, TECH_STACK, CONFIGS } from "../ZiniHub/shared/zinihubMeta";

const { shells, previewScreenByShell } = getShellsForApp("admin");

const ADMIN_APP_CONFIG = {
  id: "admin",
  title: "ZiniHub Admin",
  domain: "test-zinihub.ziniz.online",
  subtitle: "Design Wizard",
  flows: ADMIN_FLOWS,
  routes: ROUTES.admin,
  ia: IA.admin,
  shells,
  shellPreviews: previewScreenByShell,
  issues: ADMIN_ISSUES,
  accentColor: T.brand,
  folderStructure: FOLDER_STRUCTURE.admin,
  techStack: TECH_STACK.admin,
  configs: CONFIGS.admin,
};

export default function ZiniHubAdminUXWizard() {
  return <ZiniHubWizardApp appConfig={ADMIN_APP_CONFIG} />;
}
